import React from "react";

// Same "cpas design" card language as components/marketing/cloud-dashboard/
// quick-stat.tsx (frosted-glass rounded-2xl tile, icon badge on the right) —
// kept generic here since the global admin dashboard's stat set (campaigns/
// performance/finance) doesn't match that component's fixed 4-metric shape.
const GlobalAdminStatCard: React.FC<{
  label: string;
  value: React.ReactNode;
  sublabel?: React.ReactNode;
  icon: React.ReactNode;
  iconClassName?: string;
  valueClassName?: string;
}> = ({ label, value, sublabel, icon, iconClassName, valueClassName }) => (
  <div className="bg-white/60 dark:bg-gray-900/60 backdrop-blur-sm rounded-2xl p-6 border border-slate-200 dark:border-gray-700 shadow-sm">
    <div className="flex items-center justify-between gap-3">
      <div className="min-w-0">
        <p className="text-sm text-slate-500 dark:text-gray-400 mb-1 truncate">{label}</p>
        <p className={`text-2xl font-bold text-slate-800 dark:text-gray-100 ${valueClassName || ""}`}>{value}</p>
        {sublabel && <div className="mt-1 text-xs">{sublabel}</div>}
      </div>
      <div className={`p-3 rounded-xl shrink-0 ${iconClassName || "bg-blue-100 dark:bg-blue-500/15"}`}>{icon}</div>
    </div>
  </div>
);

export default GlobalAdminStatCard;
